<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Customer"
        :baseView="baseView"
        :primaryLabel="model.Name"
        :secondaryLabel="model.Code"
      />
    </template>

    <DxToolbar class="view-toolbar">
      <!-- <DxItem :options="toolbar.back" location="before" widget="dxButton" /> -->
      <DxItem #default location="center" locate-in-menu="never">
        <div class="toolbar-label">
          <b>{{ model.Name }}</b>
          &nbsp;
          <span>{{ model.Code }}</span>
        </div>
      </DxItem>
    </DxToolbar>
    <div class="view-card responsive-paddings">Customer Custom Fields</div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import { CustomerService } from "../../_services/api/customers/customer.service";
import { FeatureService } from "../../_services/api/settings/graycorp/feature.service";

export default {
  props: {},
  mixins: [BaseViewMixin],
  components: {},
  created() {
    let that = this;
    if (this.baseView.mode !== "create") {
      this.model.Code = this.baseView.id;
      this.getRecord().then((response) => {
        if (response.data.value.length > 0) {
          this.model.Code = response.data.value[0].Code;
          this.model.Name = response.data.value[0].Name;
          that.refreshView();
        }
      });
    }
  },
  data() {
    return {
      toolbar: {
        // back: {
        //   icon: "arrowleft",
        //   onClick: () => {
        //     this.$router.push({
        //       path: "/Customer"
        //     });
        //   }
        // }
      },

      model: {
        Code: "",
        Name: "",
      },
    };
  },
  computed: {
    tabs() {
      return [
        {
          text: "Customer Details",
          path: `/customer/review/${this.baseView.id}`,
          applicationFeatureCode: "Customer",
        },
        {
          text: "Custom Fields",
          path: `/customer-custom-field/review/${this.baseView.id}`,
          applicationFeatureCode: "CustomerCustomField",
        },
        {
          text: "Agent",
          path: `/customer-agent/review/${this.baseView.id}`,
          applicationFeatureCode: "CustomerAgent",
        },
        {
          text: "Contracts",
          path: `/customer-sales-contract/${this.baseView.id}`,
          applicationFeatureCode: "CustomerSalesContract",
        },
      ];
    },
  },
  methods: {
    async getRecord() {
      return await CustomerService.getByCode(this.baseView.id);
    },
    itemClick(e) {
      this.$router.push({
        path: e.itemData.path,
      });
    },
    getMenuItems() {
      // eslint-disable-next-line no-unused-vars
      FeatureService.getFeatureData().then(function(data) {
        // eslint-disable-next-line no-console
        // this.$logger.debug("Menu Data", data);
      });
    },
    backButtonFunction() {
      this.$router.push({
        path: "/Customer",
      });
    },
  },
  mounted() {
    this.selectedIndex = 1;
  },
};
</script>
